/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guides_TitleInputs */

const en_guides_title = /** @type {(inputs: Guides_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSON Guides & Tutorials: PureJSON`)
};

const ko_guides_title = /** @type {(inputs: Guides_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSON 가이드 & 튜토리얼: PureJSON`)
};

const ja_guides_title = /** @type {(inputs: Guides_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSONガイド＆チュートリアル: PureJSON`)
};

/**
* | output |
* | --- |
* | "JSON Guides & Tutorials: PureJSON" |
*
* @param {Guides_TitleInputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const guides_title = /** @type {((inputs?: Guides_TitleInputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guides_TitleInputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_guides_title(inputs)
	if (locale === "ko") return ko_guides_title(inputs)
	return ja_guides_title(inputs)
});